import { gql } from '@apollo/client';

/**
 * Untyped on purpose: codegen runs against an authenticated endpoint, so these two documents stay
 * on the plain tag until the schema change is deployed and `yarn codegen` can pick them up.
 */
export const EXPORT_REASON_SURVEY_SHOULD_ASK = gql`
  query exportReasonSurveyShouldAsk($action: ExportReasonSurveyActionEnum!) {
    exportReasonSurveyShouldAsk(action: $action)
  }
`;

export const SUBMIT_EXPORT_REASON_ANSWER = gql`
  mutation submitExportReasonAnswer(
    $action: ExportReasonSurveyActionEnum!
    $applicationCount: Int!
    $projectId: Int
    $reasonText: String!
  ) {
    submitExportReasonAnswer(
      action: $action
      applicationCount: $applicationCount
      projectId: $projectId
      reasonText: $reasonText
    )
  }
`;
